@if(isMobile) {
  <div class="navbar phone-navbar">
    <!-- <div class="nav-logo" [routerLink]="['/admin/dashboard']"> -->
    <div class="nav-logo-svg">
      <img src="assets/img/logo_PG.svg">
    </div>

 <!--   <div class="nav-logo" style="cursor: default;">
      <img src="assets/img/logo.png" style="height: 28px">
    </div>-->
    <div class="drawer-toggle-button">
      <p-button (click)="showDrawer = true" icon="pi pi-bars"   [rounded]="true" [text]="true" size="large" />
    </div>
  </div>

  <p-drawer [(visible)]="showDrawer" [header]="'gigantix' | translate" [fullScreen]="true">
    <div class="drawer-items">
      @if(authService.hasRole(['admin', 'staff'])) {
        <div class="drawer-item" (click)="showDrawer = false" [routerLink]="['/admin/centers']">
          <img src="assets/img/centers.svg" class="nav-button-icon">
          <div>{{ 'menu.centers' | translate }}</div>
        </div>
      }
      <div class="drawer-item" (click)="showDrawer = false" [routerLink]="['/admin/tournaments/active']">
        <img src="assets/img/tournaments.svg" class="nav-button-icon">
        <div>{{ 'menu.tournaments' | translate }}</div>
      </div>
      @if(authService.hasRole(['admin'])) {
        <div class="drawer-item" (click)="adminmenu.toggle($event)">
          <img src="assets/img/knight.svg" class="nav-button-icon">
          <span>{{ 'menu.admin' | translate }}</span>
        </div>
      }
      <div class="drawer-item" (click)="menu.toggle($event)" >
        <img src="assets/img/profile.svg" class="nav-button-icon">
        <span>{{ 'menu.profile' | translate }}</span>
      </div>
    </div>
  </p-drawer>
} @else {
  <div class="navbar">
    <!-- <div class="nav-logo" [routerLink]="['/admin/dashboard']"> -->
<!--    <div class="nav-logo" style="cursor: default;">
      <img src="assets/img/logo.png" style="height: 28px">
    </div>-->

    <div class="nav-logo-svg">
      <img src="assets/img/logo_PG.svg">
    </div>
    @if(authService.hasRole(['admin', 'staff'])) {
      <div class="nav-button" [routerLink]="['/admin/centers']">
        <img src="assets/img/centers.svg" class="nav-button-icon">
        <div>{{ 'menu.centers' | translate }}</div>
      </div>
    }
    <div class="nav-button" [routerLink]="['/admin/tournaments/active']">
      <img src="assets/img/tournaments.svg" class="nav-button-icon">
      <div>{{ 'menu.tournaments' | translate }}</div>
    </div>
    @if(authService.hasRole(['admin'])) {
      <div class="nav-button nav-button-square" (click)="adminmenu.toggle($event)">
        <img src="assets/img/knight.svg" class="nav-button-icon">
        <span>{{ 'menu.admin' | translate }}</span>
      </div>
    }
    <div class="nav-button nav-button-square" (click)="menu.toggle($event)" >
      <img src="assets/img/profile.svg" class="nav-button-icon">
      <span>{{ 'menu.profile' | translate }}</span>
    </div>
  </div>
}

<p-menu #menu [popup]="true" [model]="items"></p-menu>

<p-menu #adminmenu [popup]="true" [model]="itemsAdmin" [className]="'admin-menu'"></p-menu>
